goog.provide("shadow.js.shim.module$$mui$system$Stack");
goog.provide("module$shadow_js_shim_module$$mui$system$Stack");
shadow.js.shim.module$$mui$system$Stack = shadow.js.nativeProvides["@mui/system/Stack"] = shadow$bridge("@mui/system/Stack");
module$shadow_js_shim_module$$mui$system$Stack.default = shadow.js.shim.module$$mui$system$Stack;
